import { Button, Grid, IconButton, makeStyles, MenuItem, TextField, Theme, Tooltip, Typography } from '@material-ui/core';
import { Create, Delete, DeleteOutline, EditOutlined, Visibility, AttachFile, VisibilityOutlined, DescriptionOutlined } from '@material-ui/icons';
import clsx from 'clsx';
import { TableCellEnd, TableCellMiddle, TableCellStart, TableRowCustom } from 'components';

import { BLACK, PRIMARY_MOBILE, WHITE, BLUE_PRIMARY, CONFIRMATION_COLOR, PENDING_COLOR } from 'constants/colors';
import React from 'react';
import NumberFormat from 'components/NumberFormat';
import { format } from 'date-fns';

const useStyles = makeStyles((theme: Theme) => ({
  accept: {
    padding: '5px 12px 5px 12px',
    borderRadius: '100px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '22px',
    color: WHITE,
    background: BLUE_PRIMARY,
    textAlign: 'center',
    width: 120
  },
  unpaid: {
    padding: '5px 12px 5px 12px',
    borderRadius: '100px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '22px',
    color: WHITE,
    background: PENDING_COLOR,
    textAlign: 'center',
    width: 120
  },
  paid: {
    padding: '5px 12px 5px 12px',
    borderRadius: '100px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '15px',
    lineHeight: '22px',
    color: WHITE,
    background: CONFIRMATION_COLOR,
    textAlign: 'center',
    width: 120
  },
  link: {
    cursor: 'pointer',
    '&:hover': {
      color: PRIMARY_MOBILE
    }
  },
  cellStart: {
    width: '3%'
  },

  cellMiddle: {
    width: '14%'
  },
  cellMiddleDesc: {
    width: '15%'
  },
  cellEnd: {
    width: '15%'
  },
  descriptionContainer: {
    backgroundColor: WHITE,
    borderRadius: '6px',
    boxShadow: '0 2px 5px rgb(0 0 0 / 14%)',
    border: '1px solid #E0E0E0'
  },
  description: {
    color: BLACK
  },
  gap: {
    marginBottom: theme.spacing(2)
  }
}));
interface Props {
  journalTransactions: transactionJurnal;
  handleAction: (isOpen: boolean, id: number, action: 'delete' | 'update' | 'detail' | 'auhtorization', type: string) => void;
}
const TransactionBody = ({ journalTransactions, handleAction }: Props) => {
  const classes = useStyles();
  return (
    <>
      <TableRowCustom key={journalTransactions.id}>
        <TableCellStart className={clsx(classes.cellMiddle)}>{journalTransactions.jurnalNumber}</TableCellStart>
        <TableCellMiddle className={clsx(classes.cellMiddle)} align='center'>
          {' '}
          {journalTransactions.name ?? '-'}
        </TableCellMiddle>
        <TableCellMiddle className={clsx(classes.cellMiddle)}>{journalTransactions.type}</TableCellMiddle>

        <TableCellMiddle className={clsx(classes.cellMiddle)}>
          {journalTransactions.debit > 0 && journalTransactions.type !== 'Pemindahan Internal' ? (
            <>
              <div className={classes.gap}>{journalTransactions.financialAccountName}</div>
              <div className={classes.gap}>{journalTransactions.accountCategoriesName}</div>
            </>
          ) : (
            <>
              <div className={classes.gap}>{journalTransactions.accountCategoriesName}</div>
              <div className={classes.gap}>{journalTransactions.financialAccountName}</div>
            </>
          )}
        </TableCellMiddle>
        <TableCellMiddle className={clsx(classes.cellMiddle)} align='center'>
          {journalTransactions.debit > 0 ? (
            <>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.debit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.credit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
            </>
          ) : (
            <>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.credit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.debit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
            </>
          )}
        </TableCellMiddle>

        <TableCellMiddle className={clsx(classes.cellMiddle)} align='center'>
          {journalTransactions.credit > 0 ? (
            <>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.debit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.credit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
            </>
          ) : (
            <>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.credit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
              <div className={classes.gap}>
                <NumberFormat value={journalTransactions.debit} prefix={'Rp '} thousandSeparator={true} displayType='text' />
              </div>
            </>
          )}
        </TableCellMiddle>

        <TableCellMiddle className={classes.cellMiddle} align='center'>
          {format(new Date(journalTransactions.date), 'dd MMM yyyy')}
        </TableCellMiddle>
        <TableCellMiddle className={clsx(classes.cellMiddle)} align='center'>
          {' '}
          {journalTransactions.giroNumber ?? '-'}
        </TableCellMiddle>
        <TableCellEnd className={classes.cellEnd} align='right'>
          {journalTransactions.status === 'PAID' ? (
            <Typography className={classes.paid}>SUDAH CAIR</Typography>
          ) : journalTransactions.status === 'UNPAID' ? (
            <Typography className={classes.unpaid}>BELUM CAIR</Typography>
          ) : (
            ''
          )}
        </TableCellEnd>
      </TableRowCustom>
    </>
  );
};

export default TransactionBody;
